import type { Dispatch } from 'redux';
import {
    createActionFactory,
    Feature,
    createThunk,
    HubPersona,
    ThunkDispatch,
    Person,
} from '../../../shared';
import { deletePublicFolderPersona } from '../data/deletePublicFolderPersonaActions';
import { deletePersonas, deleteContact, emptyFolder } from '../data/deletePersonasActions';
import { getDisplayedItemHubPersonaIds } from '../../selectors/personaListSelector';
import { getCanPerformEmptyFolderOperation } from '../../selectors/currentPersonaOperationsSelectors';
import { getPackageState, getActiveLeftNavItemId } from '../../../appstate';
import { HubState, packageStateKey } from './../../state';
import { isCurrentHubPersonaInPublicFolder } from '../../selectors/publicFolderSelector';

export interface DeletePersonaInfo {
    deletedHubPersonaIds: string[];
    displayedHubPersonaIds: string[];
}

export const confirmDeletePersonasClickedAction = createActionFactory<DeletePersonaInfo>(
    'ConfirmDeletePersonasClickedAction',
    Feature.ContactManagement
);
export const cancelDeletePersonasClickedAction = createActionFactory<void>(
    'CancelDeletePersonasClickedAction',
    Feature.ContactManagement
);

export const confirmDeletePersonasClicked = (deletedHubPersonas: HubPersona[]) =>
    createThunk(
        'ConfirmDeletePersonasClicked',
        (dispatch: ThunkDispatch, getState: () => {}): void => {
            const state = getPackageState<HubState>(getState(), packageStateKey);

            const hubPersonaIdsToDelete = deletedHubPersonas.map(persona => persona.hubPersonaId);
            const displayedHubPersonaIds = getDisplayedItemHubPersonaIds(
                state.appState,
                state.packageState
            );
            const currentFolderId = getActiveLeftNavItemId(state.appState);
            const canPerformEmptyFolderOperation = getCanPerformEmptyFolderOperation(
                state.appState,
                state.packageState
            );
            const isPublicFolder = isCurrentHubPersonaInPublicFolder(
                state.appState,
                state.packageState
            );
            // contacts which has contactId will be deleted using CAPIv3 API
            const isContactWithContactId =
                deletedHubPersonas[0].type === 1 &&
                (deletedHubPersonas[0] as Person).info.contactId;

            dispatch(
                confirmDeletePersonasClickedAction({
                    deletedHubPersonaIds: hubPersonaIdsToDelete,
                    displayedHubPersonaIds: displayedHubPersonaIds,
                })
            );

            const isCAPIv3Enabled = state.appState.view.layoutState.isCAPIv3Enabled;

            if (canPerformEmptyFolderOperation) {
                dispatch(emptyFolder(currentFolderId, deletedHubPersonas));
            } else if (isPublicFolder) {
                dispatch(deletePublicFolderPersona(deletedHubPersonas[0], currentFolderId));
            } else if (isCAPIv3Enabled && isContactWithContactId) {
                dispatch(deleteContact(deletedHubPersonas as Person[]));
            } else {
                dispatch(deletePersonas(deletedHubPersonas));
            }
        }
    );

export const cancelDeletePersonasClicked = (dispatch: Dispatch) => () =>
    dispatch(cancelDeletePersonasClickedAction());
export type { DataActionFactory } from '../../../shared';
export type { Action } from '../../../shared';
